import { fetchIletisim as fetchIletisimAPI } from '../../services/WebsiteService';

export const FETCH_ILETISIM_SUCCESS = "FETCH_ILETISIM_SUCCESS";
export const FETCH_ILETISIM_ERROR = "FETCH_ILETISIM_ERROR";

const fetchIletisimSuccess = (iletisim) => ({
    type: FETCH_ILETISIM_SUCCESS,
    payload: iletisim,
});

const fetchIletisimError = (error) => ({
    type: FETCH_ILETISIM_ERROR,
    payload: error,
});

export const fetchIletisim = (iletisim = null) => {
    return async (dispatch) => {
        try {
            // Eğer iletisim parametre olarak gelmişse (fallback), onu kullan
            if (iletisim) {
                dispatch(fetchIletisimSuccess(iletisim));
                return;
            }
            
            // API'den çek
            const data = await fetchIletisimAPI();
            dispatch(fetchIletisimSuccess(data));
        } catch (error) {
            console.error('İletişim fetch error:', error);
            dispatch(fetchIletisimError(error.message));
            // Fallback: JSON'dan yükle
            try {
                const fallback = await import('../../data/iletisim.json');
                dispatch(fetchIletisimSuccess(fallback.default));
            } catch (e) {
                dispatch(fetchIletisimSuccess({}));
            }
        }
    };
};
